// extracted by mini-css-extract-plugin
export default {"rating":"Rating_rating__Oldwf","star":"Rating_star__LnaTA","filled":"Rating_filled__3bIRm"};